import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdvertisingMegaphone = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "advertising-megaphone" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M3.132,12.8l.448-1.175L2.534,8.881a.929.929,0,0,1,.36-1.107L5.352,6.169l.767-2.834a.928.928,0,0,1,.942-.684L9.993,2.8,12.279.955a.928.928,0,0,1,1.165,0L15.73,2.8l2.932-.146a.928.928,0,0,1,.942.684l.767,2.834,2.458,1.605a.928.928,0,0,1,.36,1.107l-1.045,2.744,1.045,2.743a.929.929,0,0,1-.36,1.108l-2.458,1.6L19.6,19.914a.927.927,0,0,1-.942.685l-2.932-.146-2.286,1.841"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 19.769,
			x2: 2.406,
			y2: 22.378
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.908,
			y1: 8.147,
			x2: 16.202,
			y2: 18.063
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "a",
			points: "15.871 17.541 2.075 21.857 1.081 20.291 10.239 8.669 15.871 17.541"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.056,20.924l.876,1.346a2.041,2.041,0,0,0,2.906.614,2.256,2.256,0,0,0,.587-3.04l-.163-.236"
		})
	]
});
export default SvgAdvertisingMegaphone;
